import React from "react";

const Inventory = () => {
	return (
		<div style={{textAlign: "center", padding: "20px 0"}}>
			<h2 style={{marginBottom: "20px"}}>Inventory coming soon ..... </h2>
			<img src="https://media.giphy.com/media/1ken0zzzL79NPy3QZj/giphy-downsized-large.gif" alt="" />
		</div>
	);
};

export default Inventory;
